import { useDeepCompareEffect, useRequest } from '@fuxi/eevee-hooks';
import { get, isEmpty } from 'lodash-es';
import Cookie from 'js-cookie';
import { MonorepoType, useLoginInfo } from '@yaotai/common-utils';
import API from '../services';

export function useAllAccountInfo({ monorepoType }: { monorepoType?: MonorepoType } = {}) {
  const { rbacUserInfo } = useLoginInfo();
  const { data, loading, run } = useRequest(() => API.current!.user.getAllAccountInfo(), {
    manual: true,
  });

  useDeepCompareEffect(() => {
    if (monorepoType === 'center' && Cookie.get('RBAC_TOKEN') && !isEmpty(rbacUserInfo)) {
      run();
    }
  }, [monorepoType, rbacUserInfo, run]);

  return {
    isGettingAllAccountsInfo: loading,
    allAccountInfo: get(data, 'data', {} as { accounts: Record<string, string> }),
    refetchAllAccountInfo: run,
  };
}
